import axios from "@/lib/axios";

const checkExistCustomerOrder = (custCode: string) => {
  return axios.get(`/facility/orders/facility_lens/exist_order?cust_code=${custCode}`);
}

export default checkExistCustomerOrder;